import { Link as MuiLink, LinkProps as MuiLinkProps } from "@mui/material";

type LinkProps = MuiLinkProps & {};

export const Link = ({ children, ...rest }: LinkProps) => {
  return (
    <MuiLink {...rest} sx={{ "&:hover": { cursor: "pointer" } }}>
      {children}
    </MuiLink>
  );
};
